/**
 *
 * @author Matthew Rawson @ 14/08/2018 15:00
 * @description
 * @notes
 * - Left as class to future proof
 */
import React, {Component} from "react"
import PropTypes from "prop-types"

import getId from "@irati/utils/id"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import {FormattedMessage} from "@irati/utils/lang"
import {injectRouteWithQuery} from "@irati/utils/helpers/routing"
import {READY_TO_LAUNCH} from "@irati/insights/constants/schedule"
import ValidationButton from "@irati/ui/src/FormItem/ValidationButton"

import {ActionsWrapper, Footer} from "../../../components/Wizard"
import sitemap from "../../../routes/sitemap"
import {NarrowStepIndicator} from "../../../ui/StepIndicator"
import {STEPS} from "../../../utils/constants/wizard"
import ValidateController from "../../../components/Wizard/Validate/ValidateController"

class Step3 extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    this.idNamespace = getId("Step3", props, {force: true})
  }

  getFooter = (schedule, handleClick, load) => {
    const {id: scheduleId, validationStatus} = schedule
    const queryParams = {scheduleId}
    const isReadyToLaunch = validationStatus === READY_TO_LAUNCH
    return (
      <Footer>
        <ActionsWrapper>
          <ButtonRouterLink id={getId("GoBackButton", this.idNamespace)} to={injectRouteWithQuery(sitemap.wizardStep2.url, {queryParams})}>
            <FormattedMessage id="insights.wizard.step3.cta.back" />
          </ButtonRouterLink>
        </ActionsWrapper>
        <NarrowStepIndicator activeStep={3} steps={STEPS} />
        <ActionsWrapper>
          {isReadyToLaunch ? (
            <ValidationButton id={getId("LaunchButton", this.idNamespace)} load={load} onClick={handleClick} primary>
              <FormattedMessage id="insights.wizard.step3.cta.next" />
            </ValidationButton>
          ) : (
            <ButtonRouterLink id={getId("GoToHomepageButton", this.idNamespace)} to={sitemap.homepage.url} primary>
              <FormattedMessage id="insights.wizard.cta.homepage" />
            </ButtonRouterLink>
          )}
        </ActionsWrapper>
      </Footer>
    )
  }

  render() {
    const {match} = this.props
    const {scheduleId} = match.params
    const backToRoute = injectRouteWithQuery(sitemap.wizardStep2.url, {queryParams: {scheduleId}})

    return (
      <ValidateController
        id={this.idNamespace}
        match={match}
        scheduleId={scheduleId}
        backToRoute={backToRoute}
        renderFooter={this.getFooter} />
    )
  }
}

export default Step3
